export const environment = {

    API_URL: process.env.VUE_APP_API_URL,

    API_SB_URL: process.env.VUE_APP_API_SB_URL,

    /** Cantidad de días que tienen que pasar para que se vuelva a calcular la 
     * localización del usuario
     */
    DIAS_PARA_LOCALIZAR: process.env.VUE_APP_DIAS_PARA_LOCALIZAR,

    /** Localidad y provincia iniciales */
    LOCALIZACION_POR_DEFECTO: {
        localidad: {
            id: 652,
            name: "Gualeguaychú",
        },
        provincia: {
            id: 15,
            name: "ENTRE RIOS"
        },
    },

    /**Token de Loqation_IQ, todavía sin usar */
    LOCATION_IQ_ACCESS_TOKEN: process.env.VUE_APP_LOCATION_IQ_ACCESS_TOKEN,

    /**Peso máximo (en formato entendible por filepond) de logos */
    LOGO_PESO_MAXIMO: process.env.VUE_APP_LOGO_PESO_MAXIMO,

    /**URL del cliente en donde se verán los comercios por QR */
    URL_COMERCIOS_QR: process.env.VUE_APP_URL_COMERCIOS_QR,

    /** TIPOS DE DESCUENTOS para Beneficios */
    ID_TIPO_DESCUENTO_STANDAR: process.env.VUE_APP_ID_TIPO_DESCUENTO_STANDAR,
    ID_TIPO_DESCUENTO_SGI: process.env.VUE_APP_ID_TIPO_DESCUENTO_SGI,

};